// extracted by mini-css-extract-plugin
module.exports = {"counter-item":"CounterItem_counter-item__3taeW","count":"CounterItem_count__2NiG0","inactive":"CounterItem_inactive__1SLYD"};